module.exports = __webpack_public_path__ + "media/images/flags/AR-07bc209f6c4b890cc115d98e7dc8d936.svg";